// AuthContext.js
import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userModules, setUserModules] = useState(
    JSON.parse(localStorage.getItem("modulos")) || []
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setUserModules(JSON.parse(localStorage.getItem("modulos")) || []);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ userModules, setUserModules }}>
      {children}
    </AuthContext.Provider>
  );
};